import TermsAndConditionsTemplate from '@/components/template/TermsAndConditionsTemplate';
import Head from 'next/head';

const Legal = () => {
  return (
    <>
      <Head>
        <title key="title">
          Terms And Conditions - {process.env.NEXT_PUBLIC_DOMAIN ?? 'EV.com'}
        </title>
        <meta
          name="description"
          content={`Terms and Conditions | ${
            process.env.NEXT_PUBLIC_DOMAIN ?? 'EV.com'
          }`}
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <main className="bg-blue-light pt-[14px]">
        <TermsAndConditionsTemplate />
      </main>
    </>
  );
};

export default Legal;
